module.exports = __webpack_public_path__ + "assets/img/b2.31289103.png";